/* src/app/auth/components/login-page/login-page.component.scss */
.container {
  display: flex;
  align-items: center;
  flex-direction: column;
}
@media (min-width: 768px) {
  .container {
    justify-content: center;
  }
}
@media (max-width: 767.98px) {
  .container .invitation-text {
    text-align: center;
  }
}
/*# sourceMappingURL=login-page.component.css.map */
